import styled, { BorderRadius, Color } from '@nfinite/react-hubstairs/styled'
import TooltipComponent from 'react-tooltip-lite'

export const TooltipContainer = styled(TooltipComponent)`
  & > .react-tooltip-lite {
    ${BorderRadius.generate({ all: 'xs' })}
    background-color: ${Color.get('background', 'contrast')};
    color: ${Color.get('text', 'contrast')};
    max-width: 800px !important;
  }

  & > .react-tooltip-lite-arrow {
    /* zIndex value does not affect the tooltip arrow so we need to force it to take the same value */
    ${({ zIndex }) => zIndex && `z-index: ${zIndex} !important;`}
    border-color: ${Color.get('background', 'contrast')};
  }

  & > .react-tooltip-lite-up-arrow {
    transform: translateY(-1px);
  }
  & > .react-tooltip-lite-down-arrow {
    transform: translateY(1px);
  }
`
